import { render, staticRenderFns } from "./AttributesQuickSearch.vue?vue&type=template&id=71cd910c&scoped=true"
import script from "./AttributesQuickSearch.vue?vue&type=script&lang=js"
export * from "./AttributesQuickSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cd910c",
  null
  
)

export default component.exports